import Box from '@mui/material/Box';
import { ItemCardPriced, ItemCardPricedProps } from '../cards/ItemCardPriced';
import { Draggable } from 'react-beautiful-dnd';

export interface ExtendedItemCardPriced extends ItemCardPricedProps {
  originalIndex?: number;
}

export type CatalogueGridItemProps = {
  item: ExtendedItemCardPriced;
  handleSelectItem: (item: ExtendedItemCardPriced) => void;
  lastRowRef?: (node: HTMLElement) => void;
  expandedItem?: ExtendedItemCardPriced;
};

interface DraggableCatalogueGridItemProps extends CatalogueGridItemProps {
  isDragEnabled: boolean;
}

export const CatalogueGridItem = ({
  item,
  handleSelectItem,
  lastRowRef,
  expandedItem,
}: CatalogueGridItemProps) => {
  return (
    <Box
      onClick={() => handleSelectItem(item)}
      ref={lastRowRef}
      sx={{
        p: 4,
        '&:hover': { cursor: 'pointer' },
        borderRadius: '10px',
        background:
          expandedItem && item.id === expandedItem.id ? '#00bcd444' : 'none',
      }}
    >
      <ItemCardPriced {...item} />
    </Box>
  );
};

export const DraggableCatalogueGridItem = ({
  isDragEnabled,
  item,
  handleSelectItem,
  lastRowRef,
  expandedItem,
}: DraggableCatalogueGridItemProps) => {
  return (
    <Draggable
      isDragDisabled={!isDragEnabled}
      draggableId={`grid-${item.id}`}
      index={item.originalIndex as number}
    >
      {(draggableProvided) => (
        <div
          {...draggableProvided.draggableProps}
          {...draggableProvided.dragHandleProps}
          ref={draggableProvided.innerRef}
        >
          <CatalogueGridItem
            lastRowRef={lastRowRef}
            handleSelectItem={handleSelectItem}
            item={item}
            expandedItem={expandedItem}
          />
        </div>
      )}
    </Draggable>
  );
};
